import { useEffect } from "preact/compat";
import { Outlet, useNavigate } from "react-router-dom";
import { PublicRoutes } from "../../src/config/routes";
import { globalState } from "#root/frontend/state.jsx";

/**
 * Require the user to be logged in, with an optional choice of where to redirect them to.
 *
 * @prop `redirect`: URL to redirect to if the user is logged in. If not set, we assume that this is a route layout.
 */
export function RequireLogin(props: { redirect?: string }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!globalState.client.isLoggedIn) {
      navigate(PublicRoutes.LOGIN);
    } else {
      if (props.redirect) {
        navigate(props.redirect);
      }
    }
  }, []);

  return <Outlet />;
}
